import * as React from 'react';
import { textStyles } from '../../tokens/text-styles';
import { colors } from '../../tokens/colors';
import { styled, theme } from 'naan/stitches.config';

export const TextStyled = styled('div', {
  color: colors['textPrimary'],
  textStyle: 'body',
});

type TextStyledProps = React.ComponentProps<typeof TextStyled>;

type TextProps = TextStyledProps & {
  children: React.ReactNode;
  textStyle?: keyof typeof textStyles;
  color?: keyof typeof theme.colors;
  as?: React.ElementType;
};

export const Text = ({
  children,
  textStyle,
  color: colorName,
  css,
  ...wrapperProps
}: TextProps) => {
  const color = colorName ? theme.colors[colorName] : undefined;
  const styles = { ...css, textStyle, color };
  return (
    <TextStyled {...wrapperProps} css={styles}>
      {children}
    </TextStyled>
  );
};
